module.exports = __webpack_public_path__ + "65f74c405569aa0cb9435734b6624cc0.png";